// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const count_ANSWERED_QUESTIONS = ["%(count)s zodpovedan\u00e1 ot\u00e1zka", "%(count)s zodpovedan\u00e9 ot\u00e1zky", "%(count)s zodpovedan\u00fdch ot\u00e1zok"];
export const FORUM_READ_MORE = "\u010c\u00edtaj viac...";
export const FORUM_TOPIC_SET_DESCRIPTION_AND_RULES = "Nastav si popis a pravidl\u00e1 kateg\u00f3rie";
export const num_POSTS_AND_ANSWERS_IN_LAST_WEEK = ["%(num)s \u010dlovek prispel za t\u00fd\u017ede\u0148", "%(num)s \u013eudia prispeli za t\u00fd\u017ede\u0148", "%(num)s \u013eud\u00ed prispelo za t\u00fd\u017ede\u0148"];
export const SUBSCRIBE_TOPIC = "Odoberaj";
export const TOPIC_COUNSELLOR = "Odborn\u00edk";
export const TOPIC_HEADER_DONT_WANT_TO_BE_SUBSCRIBED = "Nechcem odobera\u0165";
